import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";

export function Callback() {
    const {
        idToken,
        idTokenData,
        loginInProgress,
        error: loginError,
        logOut,
    } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (idToken) {
            try {
                // @ts-expect-error - heap is injected by Heap analytics
                window.heap?.identify(idTokenData?.email);
            } catch (error) {
                console.error(error);
            }

            // Store idTokenData in localStorage with clientCode extracted from custom attribute
            if (idTokenData) {
                // Extract clientCode from custom:clientCode attribute
                const processedTokenData = {
                    ...idTokenData,
                    clientCode:
                        idTokenData["custom:clientCode"] ||
                        idTokenData.clientCode,
                };

                localStorage.setItem(
                    "idTokenData",
                    JSON.stringify(processedTokenData),
                );
            }

            // Check for post-login redirect
            const redirectPath = localStorage.getItem("postLoginRedirect");
            if (redirectPath) {
                localStorage.removeItem("postLoginRedirect");
                navigate(redirectPath);
            } else {
                navigate("/");
            }
        } else if (!loginInProgress && loginError) {
            console.error("Login failed:", loginError);
            setTimeout(() => logOut(), 1500);
        } else if (!loginInProgress && !idToken) {
            navigate("/auth");
        }
    }, [idToken, idTokenData, loginInProgress, loginError, navigate, logOut]);

    if (loginInProgress) {
        return <div>Processing login...</div>;
    }
    if (!idToken && loginError) {
        toast.error("You are not authorized to login into this application.");
    }

    if (loginError) {
        return <div>Login failed. Redirecting...</div>;
    }

    return <div>Login successful. Redirecting...</div>;
}
